import type { Response } from '~/types/api/v2'

import type { WorkspaceIdentifier } from '../types'

import { useFetchWithDefaults } from '../useFetchWithDefaults'

export const useFetchChargebee = () => {
  const url = '/v2/chargebee'

  const { post, patch } = useFetchWithDefaults()

  const createPaymentIntent = ({
    workspaceId,
    payload,
  }: WorkspaceIdentifier & { payload: Omit<App.Data.Payloads.Chargebee.PaymentIntentPayload, 'currency_code'> }) => post<Response<App.Data.Chargebee.PaymentIntentData>>({
    workspaceId,
    url: `${url}/payment-intents`,
    fetchOptions: {
      body: payload,
    },
  })

  const updatePaymentIntent = ({
    workspaceId,
    payload,
  }: WorkspaceIdentifier & { payload: App.Data.Payloads.Chargebee.UpdatePaymentIntentPayload }) => patch<Response<App.Data.Chargebee.PaymentIntentData>>({
    workspaceId,
    url: `${url}/payment-intents`,
    fetchOptions: {
      body: payload,
    },
  })

  const createSepaPaymentSource = ({
    workspaceId,
    payload,
  }: WorkspaceIdentifier & { payload: Omit<App.Data.Payloads.Chargebee.PaymentSourceDirectDebitPayload, 'payment_source_type'> }) =>
    post<Response<App.Data.Chargebee.PaymentSource.PaymentSourceData>>({
      workspaceId,
      url: `${url}/payment-sources`,
      fetchOptions: {
        body: {
          ...payload,
          payment_source_type: 'direct_debit',
        } satisfies App.Data.Payloads.Chargebee.PaymentSourceDirectDebitPayload,
      },
    })

  return {
    createPaymentIntent,
    createSepaPaymentSource,
    updatePaymentIntent,
  }
}
